import { render } from "./DynamicPlayerCard.vue?vue&type=template&id=90e6477e"
import script from "./DynamicPlayerCard.vue?vue&type=script&setup=true&lang=js"
export * from "./DynamicPlayerCard.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/DynamicPlayer/DynamicPlayerCard.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "90e6477e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('90e6477e', __exports__)) {
    api.reload('90e6477e', __exports__)
  }
  
  module.hot.accept("./DynamicPlayerCard.vue?vue&type=template&id=90e6477e", () => {
    api.rerender('90e6477e', render)
  })

}


export default __exports__